export default __webpack_public_path__ + "static/squirrel-1-b0ce5bef8f77e152c225838688ab4b3a.png";